import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import AppLinkRedirect from "../components/AppLinkRedirect";
import {
  buildDeepLink,
  decodeAndValidatePublicId
} from "../utils/appLinks";

function StoryRedirect() {
  const { storyId: routeStoryId = "" } = useParams();
  const storyId = decodeAndValidatePublicId(routeStoryId);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "View a story on Mondoway | Mondoway";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <AppLinkRedirect
      deepLinkUrl={storyId ? buildDeepLink("story", storyId) : null}
      invalid={!storyId}
      openingTitle="Opening this story in Mondoway..."
      invalidTitle="This story is unavailable."
      invalidDescription="This story link is invalid, or the story may have expired."
    />
  );
}

export default StoryRedirect;
